import './assets/main.css';
import './styles/tokens.css';
import 'primeicons/primeicons.css';
import { createApp } from 'vue';
import App from './App.vue';

import { createPinia } from 'pinia';
import { DialogService } from 'primevue';
import PrimeVue from 'primevue/config';
import ToastService from 'primevue/toastservice';
import ConfirmationService from 'primevue/confirmationservice';

import router from './router';
import Tooltip from 'primevue/tooltip';

const app = createApp(App);

app.use(createPinia());

app.use(PrimeVue, {
  theme: 'none',
});
app.directive('tooltip', Tooltip);

app.use(ToastService);
app.use(DialogService);
app.use(ConfirmationService);

app.use(router);

// No MSW worker any more. It used to stub the knowledge-base routes in local
// dev and the deployed dev/test stages, one handler at a time until every
// route had a real backend; the last one (the shared-tier retrieval test) was
// retired with the action that called it, because a route with no backend
// should not look like it works in dev and 404 in prod. If a mock is ever
// needed again, gate its import on direct `import.meta.env.MODE === 'dev' ||
// import.meta.env.MODE === 'test'` comparisons (not `.includes()`), so esbuild
// can constant-fold the check and prune the mock chunk from a prod bundle.
app.mount('#app');
